export const NAV_MENU_DRAWER_TEST_ID = {
  container: 'primary-nav-container',
};
